import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLOSE_DIALOGUE } from '../../store/dialogue/dialogue.type';
import { getSetting } from '../../store/setting/setting.action';
import defaultImage from '../../../assets/images/default.jpg';
import { baseURL } from '../../../util/config';

const AffiliateReelInfoDialogue = () => {
    const dispatch = useDispatch();
    const { dialogueData } = useSelector((state) => state.dialogue);
    console.log("dialogueData affiliate reel", dialogueData);

    const { setting } = useSelector((state) => state.setting);

    const [showFullDesc, setShowFullDesc] = useState(false);

    useEffect(() => {
        dispatch(getSetting());
    }, [dispatch]);

    const truncateLength = 165;
    const description = dialogueData?.description || '';
    const isTruncateNeeded = description.length > truncateLength;

    const displayText = showFullDesc || !isTruncateNeeded
        ? description
        : description.slice(0, truncateLength) + '...';

    return (
        <div className="mainDialogue fade-in" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
            <div className="DialogueReels" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                <div className="dialogueHeader">
                    <div className="headerTitle fw-bold">Affiliate Reel Information</div>
                    <div
                        className="closeBtn"
                        onClick={() => {
                            dispatch({ type: CLOSE_DIALOGUE });
                        }}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                </div>

                <div className='row' style={{ padding: "0px 24px" }}>
                    <div className='col-4'>
                        <div className='model-body mt-3 d-flex justify-content-start'>
                            <video
                                controls
                                className="w-100"
                                height={490}
                                style={{ borderRadius: "5px" }}
                                src={dialogueData?.video}
                            />
                        </div>
                    </div>
                    <div className='col-8'>
                        <div>
                            <h4 className='fw-bold'>
                                {dialogueData?.affiliateId?.firstName + ' ' + dialogueData?.affiliateId?.lastName}
                            </h4>
                            <p style={{ color: '#666', marginBottom: '8px' }}>
                                Store: {dialogueData?.affiliateId?.storeName || dialogueData?.affiliateId?.businessName || '-'}
                            </p>
                        </div>
                        <div
                            className='row'
                            style={{
                                maxHeight: '500px',
                                overflowY: 'auto',
                                paddingRight: '12px'
                            }}>
                            {dialogueData?.products?.map((data, index) => (
                                <div
                                    key={index}
                                    className="d-flex mb-4"
                                    style={{
                                        border: "1px solid #eee",
                                        borderRadius: "8px",
                                        padding: "18px",
                                        background: "#fff",
                                        alignItems: "flex-start"
                                    }}
                                >
                                    <div className='col-4' style={{ minWidth: "180px", marginRight: "18px" }}>
                                        <img
                                            src={data?.mainImage}
                                            alt={data?.productName || "Product image"}
                                            style={{ width: "80%", borderRadius: "6px", objectFit: "cover", maxHeight: "200px" }}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = defaultImage;
                                            }}
                                        />
                                    </div>

                                    <div className='col-8'>
                                        <div className='fw-semibold mb-2' style={{ color: "#000" }}>
                                            Product Name : <span style={{ color: "#000", fontWeight: "300" }}>{data?.productName}</span>
                                        </div>
                                        <div className='fw-semibold mb-2' style={{ color: "#000" }}>
                                            Product Code : <span style={{ color: "#000", fontWeight: "300" }}>{data?.productCode}</span>
                                        </div>
                                        <div className='fw-semibold mb-2' style={{ color: "#000" }}>
                                            Product price ({`${setting?.currency?.symbol}`}) : <span style={{ color: "#000", fontWeight: "300" }}>{data?.price}</span>
                                        </div>
                                        {data?.attributes && data?.attributes.length > 0 && (
                                            <div style={{ marginTop: '12px' }}>
                                                <div className='fw-semibold' style={{ color: "#000" }}>Attributes:</div>
                                                {data?.attributes.map((attr, attrIdx) => (
                                                    <div key={attrIdx} style={{ marginBottom: "8px", marginLeft: "12px" }}>
                                                        {attr?.image && (
                                                            <img
                                                                src={baseURL + attr.image}
                                                                alt={attr.name}
                                                                style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px", marginRight: "10px" }}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = defaultImage;
                                                                }}
                                                            />
                                                        )}
                                                        <span style={{ color: "#444", fontWeight: "bold" }}>{attr?.name}:</span>
                                                        <span style={{ marginLeft: "8px" }}>
                                                            {(attr?.values || []).join(", ")}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        background: "#f8f9fa",
                        padding: "10px 28px",
                        borderRadius: "12px",
                        margin: "1px 24px 10px 24px",
                        border: "1px solid #eee",
                        display: "flex",
                        alignItems: "flex-start"
                    }}
                >
                    <i className="fa-solid fa-info-circle" style={{ fontSize: 26, marginRight: 18, color: "#377dff" }} />
                    <div style={{ fontSize: 16, color: "#343a40", fontWeight: 400 }}>
                        {dialogueData?.description || "No description available"}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AffiliateReelInfoDialogue;
